/**
 * This reducer is used for maintaining the state of the progress bar
 */
import {
    SET_PROGRESS_BAR_RETURN_STATUS,
    SET_PROGRESS_BAR_RETURN_CURRENT_STEP,
    RESET_PROGRESS_BAR_RETURN_STATUS,
    SET_PROGRESS_BAR_RETURN_EDIT_MODE,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import i18n from 'src/i18n.js';

const initialState = {
    Account: {
        label: 'Account',
        displayLabel: i18n.t('consignment.progressBar.account'),
        progress: 0,
        current: true,
        done: false,
    },
    Products: {
        label: 'Products',
        displayLabel: i18n.t('consignmentReturn.billing.products'),
        progress: 50,
        current: false,
        done: false,
    },
    Submit: {
        label: 'Submit',
        displayLabel: i18n.t('consignment.progressBar.submit'),
        progress: 0,
        current: false,
        done: false,
    },
};

const updateProgressBarState = (state, completedStep) => {
    const newState = JSON.parse(JSON.stringify(state));
    const stepsLabels = Object.keys(newState);
    const indexOfCurrentStep = stepsLabels.findIndex(
        (stepLabel) => stepLabel === completedStep
    );

    if (newState[stepsLabels[indexOfCurrentStep + 1]]) {
        newState[stepsLabels[indexOfCurrentStep + 1]].progress = 100;
        if (newState[stepsLabels[indexOfCurrentStep + 2]])
            newState[stepsLabels[indexOfCurrentStep + 2]].progress = newState[
                stepsLabels[indexOfCurrentStep + 2]
            ].progress
                ? newState[stepsLabels[indexOfCurrentStep + 2]].progress
                : 50;
        newState[stepsLabels[indexOfCurrentStep + 1]].current = true;
        newState[stepsLabels[indexOfCurrentStep + 1]].done = false;
    }

    newState[completedStep].current = false;
    newState[completedStep].done = true;
    return newState;
};

const setProgressBarCurrentStep = (state, currentStep) => {
    const newState = JSON.parse(JSON.stringify(state));
    // Keep track of the step indexes for proper "done" status management
    const stepsLabels = Object.keys(newState);
    const currentStepIndex = stepsLabels.indexOf(currentStep);
    
    Object.keys(newState).forEach((step, index) => {
        if (step === currentStep) {
            // Set the current step
            newState[step].current = true;
            // Don't mark it as done when it becomes current
            // If we're moving back to a previous step, keep it done
            if (newState[step].done && index < currentStepIndex) {
                newState[step].done = true;
            }
        } else {
            // Not the current step
            newState[step].current = false;
            
            // All steps before the current one should be marked as done
            if (index < currentStepIndex) {
                newState[step].done = true;
            }
            // Steps after the current should not be marked as done
            // unless they were already completed in a previous navigation
        }
    });
    return newState;
};

const progressBarReducer = (state = initialState, action) => {
    // const { t } = useTranslation();
    switch (action.type) {
        case SET_PROGRESS_BAR_RETURN_STATUS:
            return {
                ...updateProgressBarState(state, action.payload),
            };
        case SET_PROGRESS_BAR_RETURN_CURRENT_STEP:
            return {
                ...setProgressBarCurrentStep(state, action.payload),
            };
        case RESET_PROGRESS_BAR_RETURN_STATUS:
            return {
                Account: {
                    label: 'Account',
                    displayLabel: i18n.t('consignment.progressBar.account'),
                    progress: 0,
                    current: true,
                    done: false,
                },
                Products: {
                    label: 'Products',
                    displayLabel: i18n.t('consignmentReturn.billing.products'),
                    progress: 50,
                    current: false,
                    done: false,
                },
                Submit: {
                    label: 'Submit',
                    displayLabel: i18n.t('consignment.progressBar.submit'),
                    progress: 0,
                    current: false,
                    done: false,
                },
            };
        case SET_PROGRESS_BAR_RETURN_EDIT_MODE:
            return action.payload;
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'consignmentReturnProgressBarKey',
        storage: storage,
    },
    progressBarReducer
);
